import React from 'react'
import styled from 'styled-components'
import { QuestionnaireFormLabel } from 'spa/member/components/WorkPreference/QuestionnaireFormLabel'
import { DateInput } from 'spa/member/components/DateInput'

export type Props = {
  name: string,
  label: string | React.ReactNode,
  annotationNote?: string,
  required?: boolean,
  rules?: any,
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>,
  labelProps?: React.InputHTMLAttributes<HTMLLabelElement>,
  dataCy?: string,
}

const StyledFormContainer = styled.div`
  width: 100%;
`

export const StyledDateForm: React.FC<Props> = (props: Props) => {
  return (
    <StyledFormContainer data-cy={props.dataCy}>
      <QuestionnaireFormLabel {...props.labelProps} htmlFor={props.name} label={props.label} required={props.required} annotationNote={props.annotationNote} />
      <DateInput {...props.inputProps} id={props.name} name={props.name} required={props.required} rules={props.rules} />
    </StyledFormContainer>
  )
}
